import React from 'react'
import {
  Box,
  Typography,
  Card,
  CardActions,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material'
import { Settings as SettingsIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

/**
 * 设置面板组件（仅语言风格；题目类型与「是否生成题目」在状态栏统一控制）
 */
const SettingsPanel = ({
  contentStyle,
  onContentStyleChange,
}) => {
  const { t } = useTranslation()

  return (
    <Card sx={{ mb: 2, border: `1px solid`, borderColor: 'divider' }}>
      <CardActions
        sx={{
          p: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SettingsIcon fontSize="small" />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {t('uploadNotebook.contentStyle') || '语言风格'}
          </Typography>
        </Box>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <Select
            value={contentStyle}
            onChange={(e) => onContentStyleChange(e.target.value)}
            size="small"
            displayEmpty
          >
            <MenuItem value="auto">{t('uploadNotebook.styleAuto') || '自动匹配（根据原文风格）'}</MenuItem>
            <MenuItem value="casual">{t('uploadNotebook.styleCasual') || '口语化（贴近学生、易懂）'}</MenuItem>
            <MenuItem value="professional">{t('uploadNotebook.styleProfessional') || '专业化（学术、正式）'}</MenuItem>
          </Select>
        </FormControl>
      </CardActions>
    </Card>
  )
}

export default SettingsPanel
